module.exports = __webpack_public_path__ + "img/mr.4a520f68.svg";